import * as ProviderTypes from './ProviderTypes';

export const getProviders = (list = [], container) => {
  return Promise.all(
    list.map(async provider => {
      provider = await providers[provider]();
      return new provider.default(container);
    })
  );
};

export const providers = {};
providers[ProviderTypes.IAS]           = () => import('./IASProvider');
providers[ProviderTypes.MOAT]          = () => import('./MoatProvider');
providers[ProviderTypes.DOUBLE_VERIFY] = () => import('./DoubleVerifyProvider');


// WEBPACK FOOTER //
// ./src/Services/Measurement/ExternalProviders/ProviderFactory.js